module.exports = __webpack_public_path__ + "static/media/app-store.89c880db.png";